import { ConfigService } from '@maia/config';
import { HttpService } from '@maia/httpClient';
import { CmsService } from '@maia/shared';
import { CmsController } from './cms.controller';

export class ServiceFactory {
  private readonly configService = new ConfigService();
  private readonly httpService = new HttpService(this.configService, 'cmsUrl');

  createCmsController(): CmsController {
    return new CmsController(this.createCmsService());
  }

  private createCmsService() {
    return new CmsService(this.httpService, this.configService);
  }
}

const factory = new ServiceFactory();
export const service = factory.createCmsController();
